<template>
  <div
    class="media mt-3 w-100 border rounded"
    style="background: white"
    v-if="tibModel"
  >
    <a :href="tibModel.url" target="_blank"
      ><img
        class="align-self-start mt-3 mx-3"
        :src="tibModel.imageUrl"
        style="width:100px;height:100%;"
    /></a>
    <div class="media-body mt-2">
      <h5 class="card-title">
        <a :href="tibModel.url" style="overflow-wrap: break-word;
      word-break: break-all;">{{ tibModel && tibModel.name }}</a>
      </h5>
      <p>{{ tibModel && tibModel.path }}</p>
      <p>{{ tibModel && getReadableFileSizeString(tibModel.size) }}</p>
      <p>{{ new Date(tibModel.version).toISOString() }}</p>
      <div class="md" v-html="getHtml(tibModel)"></div>
      <a :href="baseUrl + '/ib/' + tibModel.tag"
        ><img
          class="align-self-start mx-3"
          :src="'/tt/tib/' + tibModel.tag + '/qr.png?size=100'"
      /></a>
    </div>
  </div>
</template>

<script>
import { baseUrl } from "@/common/constants";
import { getReadableFileSizeString, getHtml } from "@/common/utils";
export default {
  name: "tibView",
  data: function() {
    return {
      tibModel: null,
      getReadableFileSizeString: getReadableFileSizeString,
      getHtml: getHtml,
      baseUrl: baseUrl
    };
  },
  mounted() {
    this.tibModel = this.tibModelProperty;
  },
  watch: {
    tibModelProperty() {
      this.tibModel = this.tibModelProperty;
    }
  },
  methods: {},
  props: {
    tibModelProperty: Object,
    tp: Object
  }
};
</script>
